import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list';
export default {
  components: {
    eSearch,
    eTableList,
  },
};

/* 
列表
<e-table-list
  :index-show="true"
  style="margin-top: 20px; width: 100%"
  :row-key="'purchaseDemandItemId'"
  :table-data="tableData"
  :table-label="tableLabel"
  :selection-show="true"
  ref="multipleTable"
  @handleSelectionChange="handleSelectionChange"
  @handleSelectAll="handleSelectAll"
>
  <template v-slot:code="tData">
    <el-link type="primary" :underline="false" @click="handleCodeDetail(tData.scope.row)">
      {{ tData.scope.row.purchaseDemandCode }}
    </el-link>
  </template>
</e-table-list>

tableLabel: [
  {
    label: '物料分类',
    param: 'categoryName',
    align: 'center',
    fixed: 'left',
    width: '140',
  },
  {
    label: '物料编码',
    align: 'center',
    render: row => {
      return row.categoryCustomCode || '-';
    },
    fixed: 'left',
    width: '140',
    slot: 'tData'
  },
]


<e-search
  :data="queryData" // 搜索数据model
  :field-list="fieldList"
  @handleFilter="handleFilter"
  @handleReset="handleReset"
></e-search>

// 搜索内容展示
fieldList: [
  {
    label: '需求计划名称',
    type: 'input',
    value: 'purchaseDemandName',
  },
  {
    label: '需求计划编号',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '创建日期',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
  },
  { label: '物料描述', type: 'input', value: 'categoryDesc' },
],
*/
